window.$ = window.jQuery = require("jquery");
import { Tooltip, Toast, Popover } from "bootstrap";

window.Embed = class Embed {
    constructor({ embed, meta }) {
        this.url = meta.url;
        this.meta = meta;

        embedpano(embed);
    }

    showTooltip(element, timer = null) {
        var tooltip = new Tooltip(element);

        tooltip.show();

        if (timer != null) {
            setTimeout(function () {
                tooltip.disable();
            }, timer);

            element.addEventListener("mouseout", tooltip.disable());
        }
    }

    copyToClipboard(content) {
        if (window.isSecureContext) {
            if (navigator.clipboard) {
                navigator.clipboard
                    .writeText(content)
                    .then(() => {
                        console.log("Text copied to clipboard...");
                    })
                    .catch((err) => {
                        console.log("Something went wrong copping text", err);
                    });
            }
        } else {
            console.log("Context not secure");
        }
    }

    // Open URl in a PopUP
    popitup({ url, title, w, h }) {
        let win = window.parent;
        let y = win.top.outerHeight / 2 + win.top.screenY - h / 2;
        let x = win.top.outerWidth / 2 + win.top.screenX - w / 2;
        return win.open(
            url,
            title,
            "toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=" +
                w +
                ", height=" +
                h +
                ", top=" +
                y +
                ", left=" +
                x,
        );
    }

    // Generate Share URlS
    share(type) {
        let url = null;
        if (type === "copy_to_clipboard") {
            this.copyToClipboard(this.meta.url);
        } else if (type === "facebook") {
            url =
                "https://www.facebook.com/sharer/sharer.php?u=" +
                encodeURIComponent(this.meta.url) +
                "&title=" +
                this.meta.title;
        } else if (type === "linkedin") {
            url =
                "https://www.linkedin.com/shareArticle?mini=true&url=" +
                this.meta.url +
                "&summary=" +
                this.meta.title +
                "&source=Linkedin";
        } else if (type === "twitter") {
            url =
                "https://twitter.com/intent/tweet?url=" +
                encodeURIComponent(this.meta.url) +
                "&text=" +
                this.meta.title;
        } else if (type === "email") {
            url =
                "mailto:?Subject=" +
                this.meta.title +
                "&body=" +
                encodeURIComponent(this.meta.url);
        }

        if (url !== null) {
            this.popitup({
                url: url,
                title: "Share",
                w: 500,
                h: 400,
            });
        }
    }
};
